import { Contact } from './contact';
import { Customer, RelatedPartner } from './customer';

export class Location {
    id: string;
    name: string;
    properties: { [propertyName: string]: string | number | Contact[] };
    customer: Customer;
    country: string;
    gpsPosition: string;
    timezone: string;
    metrics: { [metricName: string]: { value: any, lastUpdateTimestamp: number } };
    partner?: RelatedPartner;
    externalId?: string;
    lastUpdateTimestamp?: number;
    lastSyncTimestamp?: number;
}